/*
 * mtw-prefetch.js — letvægts link-prefetch (erstatter SPDN/Hyperspeed-pluginet).
 * Prefetcher samme-origin sider på hover (desktop) / tryk eller kort hold (mobil), så klik føles øjeblikkelige.
 * Springer cart/checkout/account + add-to-cart-links over. Respekterer data-saver / langsomt net.
 * Ingen afhængigheder, ingen 3.-parts-app, ingen tracking.
 */
(function () {
  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|\b)(2g|slow-2g|3g)($|\b)/.test(conn.effectiveType || ''))) return;
  try {
    if (!document.createElement('link').relList.supports('prefetch')) return;
  } catch (e) { return; }

  var prefetched = Object.create(null);
  var hoverTimer = null;
  var lastTouch = 0;
  var touchTimer = null;
  var touchLink = null;
  var touchX = 0;
  var touchY = 0;
  var HOLD_MS = 150;    // fingeren har ligget stille så længe: det er et tryk på vej, ikke en scroll
  var MOVE_PX = 10;     // bevæger fingeren sig mere end det, er det en scroll

  function prefetch(url) {
    if (prefetched[url]) return;
    prefetched[url] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  }

  function eligible(a) {
    if (!a || !a.href || a.origin !== location.origin) return false;     // kun eget domæne
    if (a.pathname === location.pathname) return false;                  // ikke nuværende side
    if (a.hasAttribute('download') || a.target === '_blank') return false;
    if (/\/(cart|checkout|account)(\/|$)/.test(a.pathname)) return false; // dynamiske/private
    if (/[?&](add|variant|logout|return_url)=/.test(a.search)) return false;
    return true;
  }

  function anchor(e) {
    return e.target && e.target.closest ? e.target.closest('a') : null;
  }

  // Desktop: hover med lille forsinkelse, så vi ikke prefetcher alt man stryger forbi.
  document.addEventListener('mouseover', function (e) {
    if (Date.now() - lastTouch < 1100) return; // mouseover affyres også efter touch — ignorér
    var a = anchor(e);
    if (!eligible(a)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { prefetch(a.href); }, 65);
  }, { passive: true, capture: true });

  document.addEventListener('mouseout', function () { clearTimeout(hoverTimer); }, { passive: true, capture: true });

  // Mobil: en berøring kan lige så godt være starten på en scroll, og en hel side koster ca. 125 KB.
  // Derfor prefetches først ved et kort hold eller når fingeren slippes uden at have flyttet sig.
  function touchReset() {
    clearTimeout(touchTimer);
    touchLink = null;
  }

  document.addEventListener('touchstart', function (e) {
    lastTouch = Date.now();
    touchReset();
    if (e.touches.length !== 1) return;
    var a = anchor(e);
    if (!eligible(a)) return;
    touchLink = a;
    touchX = e.touches[0].clientX;
    touchY = e.touches[0].clientY;
    touchTimer = setTimeout(function () { prefetch(a.href); }, HOLD_MS);
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function (e) {
    if (!touchLink) return;
    var t = e.touches[0];
    if (Math.abs(t.clientX - touchX) > MOVE_PX || Math.abs(t.clientY - touchY) > MOVE_PX) touchReset();
  }, { passive: true, capture: true });

  document.addEventListener('touchend', function () {
    lastTouch = Date.now();
    if (touchLink) prefetch(touchLink.href);
    touchReset();
  }, { passive: true, capture: true });

  document.addEventListener('touchcancel', touchReset, { passive: true, capture: true });
})();
